import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface termsState {
  titleKeys: string;
  contentKeys: '' | 'service' | 'privacy' | 'refund' | 'specialLaw';
}

const initialState: termsState = {
  titleKeys: '',
  contentKeys: '',
};

const termsSlice = createSlice({
  name: 'terms',
  initialState: initialState,
  reducers: {
    setTermsTitleKeys: (state, action: PayloadAction<string>) => {
      state.titleKeys = action.payload;
    },
    setTermsContentKeys: (
      state,
      action: PayloadAction<
        '' | 'service' | 'privacy' | 'refund' | 'specialLaw'
      >,
    ) => {
      state.contentKeys = action.payload;
    },
  },
});

export const { setTermsTitleKeys, setTermsContentKeys } = termsSlice.actions;

export default termsSlice.reducer;
